import { IExperiment } from '../types/experiments';

export enum EAbFiltersPriceGroup {
  /** Контрольная группа, никаких изменений */
  NothingChanged = 0,
  /** Фильтр цены убран полностью */
  NoPriceFilter = 1,
  /** Из фильтра цены убран "От" */
  NoFromPriceFilter = 2,
}

export const experimentSections = ['index', 'sale', 'rent'];

export const getFiltersPriceGroup = (experiments: IExperiment[]): EAbFiltersPriceGroup => {
  const abNewbuildingsSearchExperiment = experiments.find(e => e.name === 'audience_mainpage_filters_price');

  return (abNewbuildingsSearchExperiment && abNewbuildingsSearchExperiment.abGroup) || 0;
};
